@let serverVersion = healthService.serverVersion$ | async;

<img
  routerLink="/home"
  src="images/logo_name.svg"
  alt="ideastream.io Logo mit Text"
  class="logo"
/>
<rr-btn
  type="Primary"
  size="small"
  iconStart="close"
  *ngIf="showHeaderBackButton === true"
  (btnclick)="goOnePageBack()"
  i18n
  >Close</rr-btn
>
<div class="sidebar row gap-16" *ngIf="showHeaderBackButton === false">
  <rr-icon class="help" name="help" (click)="gotoFaq()"></rr-icon>
  <div
    class="useraccountmenue col"
    [ngClass]="userAccountMenueIsOpen == true ? 'open' : ''"
  >
    <div class="row">
      <rr-user-avatar [user]="user"></rr-user-avatar>
      <div class="name">
        {{ user.prename ? user.prename + " " + user.lastname : user.email }}
      </div>
      <rr-icon
        name="chevron-down"
        class="pointer chevron"
        (click)="toggleUserMenue()"
      ></rr-icon>
    </div>
    <div class="backdrop" (click)="toggleUserMenue()"></div>
    <div class="menucontent col">
      <div class="personaldata row">
        <rr-user-avatar [user]="user"></rr-user-avatar>
        <div class="col">
          <div class="name">
            {{ user.prename ? user.prename + " " + user.lastname : user.email }}
          </div>
          <div class="email tiny">{{ user.email }}</div>
        </div>
      </div>
      <rr-divider></rr-divider>
      <div
        class="settings row"
        routerLink="/home/account"
        (click)="toggleUserMenue()"
      >
        <rr-icon name="user"></rr-icon>
        <span i18n>Profile Settings</span>
      </div>
      <div class="language row" (click)="switchLanguage()">
        <rr-icon name="german"></rr-icon>
        <span i18n>Switch to German</span>
      </div>
      <rr-divider></rr-divider>
      <div class="logout row" (click)="logout()">
        <rr-icon name="logout"></rr-icon>
        <span i18n>Logout</span>
      </div>

        <rr-divider></rr-divider>
        <span class="app-version row">
            App Version: {{ appVersion }}
        </span>

        <span class="app-version row">
            Server Version: {{ serverVersion }}
        </span>
    </div>
  </div>
</div>

